import { render, staticRenderFns } from "./UserForms.vue?vue&type=template&id=653638c0&scoped=true"
import script from "./UserForms.vue?vue&type=script&lang=js"
export * from "./UserForms.vue?vue&type=script&lang=js"
import style0 from "./UserForms.vue?vue&type=style&index=0&id=653638c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653638c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653638c0')) {
      api.createRecord('653638c0', component.options)
    } else {
      api.reload('653638c0', component.options)
    }
    module.hot.accept("./UserForms.vue?vue&type=template&id=653638c0&scoped=true", function () {
      api.rerender('653638c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinForm/UserForms.vue"
export default component.exports